//
// Copyright 2026 DXOS.org
//

/**
 * Scrollbar sizing presets keyed by density tier.
 */
export const scrollbar = {
  sm: {
    size: 2,
    padding: 2,
  },
  md: {
    size: 4,
    padding: 4,
  },
  lg: {
    size: 8,
    padding: 8,
  },
};
